module.exports = __webpack_public_path__ + "media/images/iconDown__inactive--dark-856a63e275f664c416b5b03f624c24ce.png";